
const PUSH_TO_CALENDAR_DATA = (state, payload) => { state.calendarData.push(payload) }
const SET_CALENDAR_DATA = (state, payload) => { state.calendarData = payload }
const RESET_CALENDAR_DATA = (state) => { state.calendarData = [] }

const SET_ISLOADING = (state, payload) => { state.isLoading = payload }
const RESET_ISLOADING = (state) => { state.isLoading = false }

const SET_VERIFIED_BOOKINGS = (state, payload) => { state.verifiedBookings = payload }
const RESET_VERIFIED_BOOKINGS = (state) => { state.verifiedBookings = null }

const SET_BOOKING_DETAILS = (state, payload) => { state.bookingDetails = payload }
const RESET_BOOKING_DETAILS = (state) => { state.bookingDetails = [] }

const SET_BILL_ITEM_DETAILS = (state, payload) => { state.billItemDetails = payload }
const RESET_BILL_ITEM_DETAILS = (state) => { state.billItemDetails = [] }

const SET_BOOKING_PAID_PAID_STATUS_ARRAY = (state, payload) => { state.bookingPaidStatusArray = payload }
const RESET_BOOKING_PAID_PAID_STATUS_ARRAY = (state) => { state.bookingPaidStatusArray = [] }
 
export default {
    PUSH_TO_CALENDAR_DATA,
    SET_CALENDAR_DATA,
    RESET_CALENDAR_DATA,

    SET_ISLOADING,
    RESET_ISLOADING,

    SET_BOOKING_DETAILS,
    RESET_BOOKING_DETAILS,

    SET_BILL_ITEM_DETAILS,
    RESET_BILL_ITEM_DETAILS,

    SET_BOOKING_PAID_PAID_STATUS_ARRAY,
    RESET_BOOKING_PAID_PAID_STATUS_ARRAY,

    SET_VERIFIED_BOOKINGS,
    RESET_VERIFIED_BOOKINGS,
}